import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Error as ErrorBoundary } from "../../../../components";
import layoutHOC from "HOC/layoutHOC";
import config from "constants/config";
import Header from "./header";
import Setup from "../../screens/setup";
import useWindowSize from "../../../../hooks/useWindowSize";
import "./index.scss";


const SetupLayout = () => {

	const [step, setStep] = useState(0);
	const { windowHeight } = useWindowSize();

	return (
		<GoogleReCaptchaProvider reCaptchaKey={config.CAPTCHA_SITE_KEY_V3}>
			<ErrorBoundary>
				<>

					<Header step={step} setStep={setStep} />

					<div className="app-body" style={{ height: `calc(${windowHeight}px - 3.5rem - 3.5rem)`, backgroundColor: "transparent" }}>
						<main className="main ml-0">
							<div className="container" style={{ maxWidth: 1280, backgroundColor: "transparent" }}>
								<div className="setup-screen">
									<div className="setup-content-wrapper">
										<Switch>
											<Route path="/setup" render={(props) => <Setup step={step} setStep={setStep} {...props} />} />
										</Switch>
									</div>
								</div>
							</div>
						</main>

					</div>

				</>
			</ErrorBoundary>
		</GoogleReCaptchaProvider>
	)

}

export default layoutHOC(SetupLayout)
